import * as React from 'react';

import { ClientContactView } from './client-contact.view';
import { CardController } from 'src/app/shared/card.controller';

interface ClientContactControllerProps extends ComponentViewProps<ClientItem> {
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
}

export class ClientContactController extends React.Component<ClientContactControllerProps, any> {
	constructor(props) {
		super(props);
	}

	render() {
		if (this.props.model == null) {
			return null;
		}

		const model = this.props.model;
		return (
			<CardController
				icon="contacts"
				className="card-borderless"
				title="Contact info"
				mode={this.props.mode}>
				<ClientContactView
					mode={this.props.mode}
					model={model}
					setBusy={this.props.setBusy}
				/>
			</CardController>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/crm/clients/form/parts/client-contact.controller.tsx